import { render, staticRenderFns } from "./PerformanceShop.vue?vue&type=template&id=38a82c75&scoped=true&"
import script from "@/views/PerformanceShop/PerformanceShop.ts?vue&type=script&lang=ts&"
export * from "@/views/PerformanceShop/PerformanceShop.ts?vue&type=script&lang=ts&"
import style0 from "@/views/PerformanceShop/PerformanceShop.scss?vue&type=style&index=0&id=38a82c75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a82c75",
  null
  
)

export default component.exports